import { getUserType } from '@/modules/userUtils';
import sendAnalyticsErrorEvent from '../sendAnalyticsErrorEvent';
import getAnalyticsPreferencesData from './getAnalyticsPreferencesData';

export default function getAnalyticsUserData(globalContext, studentContext) {
  try {
    const { user, availableLanguages } = globalContext;
    const { subscription: studentSubscription } = studentContext;

    const userData = {
      userType: null,
      subscriptionType: null,
      userLanguage: availableLanguages?.toString(),
      status: null,
      trial: null,
      ...getAnalyticsPreferencesData(user),
    };

    const userType = getUserType(user);

    if (user) {
      userData.userType = userType;

      if (userType == 'student') {
        if (studentSubscription) {
          userData.subscriptionType = studentSubscription.subscriptionType.code;
          userData.trial = studentSubscription.trial;
          userData.status = studentSubscription.status;
          userData.subscriptionHash = hashSubscriptionId(studentSubscription);
        }
        if (studentContext.isSharedStudent) {
          userData.isSharedStudent = true;
        }
      } else if (userType == 'teacher') {
        const subscription = user.teacher.subscription;
        userData.subscriptionType = subscription?.subscriptionType?.code;
        userData.trial = subscription?.trial;
        userData.status = subscription?.status;
        userData.subscriptionHash = hashSubscriptionId(subscription);
      }
    }
    return userData;
  } catch (err) {
    sendAnalyticsErrorEvent(
      {
        enventMame: 'Problem getting userData',
        handler: 'getAnalyticsUserData',
      },
      err
    );
    return {};
  }
}

function hashSubscriptionId(subscription) {
  try {
    const hashInput = 'subscription_' + subscription.id;
    let hash = 0;
    for (let i = 0; i < hashInput.length; i++) {
      const char = hashInput.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    return Math.abs(hash).toString(16).padStart(8, '0').substring(0, 8);
  } catch (err) {
    return subscription.id;
  }
}
